import { useTeam } from "../../../hooks/useTeam.ts";
import { Loader, Title, Text, Image, Stack } from "@mantine/core";

export const TeamSponsor = (props: { teamId: string }) => {
  const teamData = useTeam(props.teamId);

  if (!teamData.isSuccess) {
    return <Loader />;
  }

  return (
    <Stack gap="xs">
      <Title order={2}>{teamData.data.name}</Title>
      {teamData.data.sponsor && (
        <>
          <Text>Sponsor: {teamData.data.sponsor.name}</Text>
          <Text>
            Link:{" "}
            <a
              href={teamData.data.sponsor.url}
              target="_blank"
              rel="noreferrer"
            >
              {teamData.data.sponsor.url}
            </a>
          </Text>
          <Image
            src={`${teamData.data.sponsor.logoFilePath ?? "https://example.com"}?cacheBust=${Date.now()}`}
            w={200}
            fit="contain"
            fallbackSrc={`https://placehold.co/600x300?text=Datei+fehlt`}
          />
          <Image
            src={`${(
              teamData.data.sponsor.ledwallFilePath ?? "https://example.com"
            )
              .replace("$width", "1920")
              .replace("$height", "144")
              .replace("$screenId", "1")}?cacheBust=${Date.now()}
              `}
            w={600}
            maw="100%"
            fit="contain"
            fallbackSrc={`https://placehold.co/1200x144?text=Datei+fehlt`}
          />
        </>
      )}
    </Stack>
  );
};
